import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './listing-availability.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ListingAvailability = props => ___EmotionJSX("div", {
  css: styles.listingAvailability
}, ___EmotionJSX(Heading, {
  css: styles.heading,
  title: "Availability"
}), ___EmotionJSX("div", {
  css: styles.body
}, props.dateFrom && !props.availableNow && ___EmotionJSX("span", null, "Available from ", ___EmotionJSX("span", {
  css: styles.date
}, props.dateFrom), props.dateTo && ___EmotionJSX("span", null, ' ', "to ", ___EmotionJSX("span", {
  css: styles.date
}, props.dateTo))), props.availableNow && ___EmotionJSX("span", null, "Available now")));
ListingAvailability.propTypes = {
  availableNow: PropTypes.bool,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string
};
ListingAvailability.defaultProps = {
  availableNow: false,
  dateFrom: null,
  dateTo: null
};
export default ListingAvailability;